import { CheckCircle2, LockKeyhole, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: LockKeyhole, label: "Minimum 8 characters" },
  { icon: CheckCircle2, label: "Confirmation check before save" },
  { icon: ShieldCheck, label: "Security check protects the update" },
];

export default function Nd1ResetPasswordMarketing() {
  return (
    <aside className="nd1-auth-aside nd1-auth-aside--signin" aria-label="New password guidance">
      <div className="nd1-auth-aside__copy">
        <p className="nd1-auth-card__eyebrow">Secure password update</p>
        <h1 className="nd1-auth-aside__title">
          <span className="nd1-ink">Choose a new password</span>
          <span className="nd1-ink-green">with confidence.</span>
        </h1>
        <p className="nd1-auth-aside__lede">
          Use your email reset link once, choose a new password, then sign in again securely.
        </p>
      </div>
      <ul className="nd1-auth-aside__features">
        {FEATURES.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon className="nd1-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
